import { useIsMobileDevice } from 'lib/hooks/useIsMobile';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LoginForm from './pages/LoginForm/Main/Login/index';
import AppRoutes from './routes';
import MobileRoutes from './routesMobile';
import OpenRoutes from './routesOpen';
import PruffConnectRoutes from './routesPruffConnect';
import PruffConnectOpenRoutes from './routesPruffConnectOpen';
import { logout } from './services/redux/authSlice';
import { RootState } from './services/redux/store';

export const DATA_VERSION = '1.1';
// To test from mobile add 192 to the app domains
export const APP_DOMAINS = ['app', 'localhost', 'dev'];

const App: React.FC = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state: RootState) => state.auth);
  const isMobile = useIsMobileDevice();
  const domain = window.location.hostname;
  const subdomain = domain.split('.')[0];
  const isPruffConnect = !APP_DOMAINS.includes(subdomain);

  if (isPruffConnect) {
    if (auth.isAuthenticated) {
      return <PruffConnectRoutes />;
    }
    return <PruffConnectOpenRoutes />;
  }

  if (auth.isAuthenticated) {
    const userProperties = [
      'email',
      'name',
      'companyName',
      'permissionPolicy',
      'id',
      'roles',
      'companyTypes',
      'companyId',
    ];

    const hasAllProperties = userProperties.every(
      (prop) =>
        auth.user && Object.prototype.hasOwnProperty.call(auth.user, prop),
    );
    if (auth.user?.dataVersion !== DATA_VERSION) {
      dispatch(logout());
      return <LoginForm />;
    }
    if (!hasAllProperties) {
      dispatch(logout());
      return <LoginForm />;
    }

    if (isMobile) {
      return <MobileRoutes />;
    }
    return <AppRoutes />;
  }

  if (isMobile) {
    dispatch(logout());
    return <OpenRoutes />;
  }
  return <OpenRoutes />;
};

export default App;
